import { CSSProperties } from "react";

import { colors } from "#app/theme/v1/colors";
import { SimilarPartFilters } from "#modules/similarPart/view/filters/SimilarPartFilters";
import { Paper } from "#shared/view/components/Paper";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { TitleWithIcon } from "#shared/view/components/TitleWithIcon";
import { FilterQuery } from "shared";

type Props = {
  onSubmit: (params: FilterQuery) => void;
  filtersParams: FilterQuery;
};

export const SimilarPartFiltersSection = ({ onSubmit, filtersParams }: Props) => {
  return (
    <Paper style={styles.wrapper} shadow="lg" p="md" w="80%">
      <TitleWithIcon title="Rechercher une pièce manuellement" iconName="search" />
      <Space h="xs" />
      <Text fw="bold">Ajouter un filtre de recherche</Text>
      <Space h="sm" />
      <SimilarPartFilters
        onUpdateFilters={onSubmit}
        filtersParams={filtersParams}
        hasDimensionsFilter={false}
      />
    </Paper>
  );
};

const styles: Record<string, CSSProperties> = {
  wrapper: {
    border: "1px solid ",
    borderColor: colors.gray[2],
  },
};
